import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { useAuthContext } from '@/src/features/app/store/auth/context';
import { APP } from '@/src/features/app/app.constants';
import { Loader } from '@/src/features/_predefined/loader/Loader';

const LazyDashboardLayout = lazy(async () => {
  const { DashboardLayout } = await import('@/src/features/modules/dashboard/layout/Layout');
  return { default: DashboardLayout };
});

const LazyHomePage = lazy(async () => {
  const { DashboardHomePage } = await import('@/src/features/modules/dashboard/pages/home/Page');
  return { default: DashboardHomePage };
});

const LazyNutritionsPage = lazy(async () => {
  const { NutritionsPage } = await import('@/src/features/modules/dashboard/pages/nutritions/Page');
  return { default: NutritionsPage };
});

const LazyIngredientsPage = lazy(async () => {
  const { IngredientsPage } = await import('@/src/features/modules/dashboard/pages/ingredients/Page');
  return { default: IngredientsPage };
});

const router = createBrowserRouter([
  {
    path: APP.ROUTES.ROOT,
    element: <Navigate to={APP.ROUTES.DASHBOARD} replace />,
  },
  {
    element: <LazyDashboardLayout />,
    handle: {
      translationTitleKey: 'PAGES.HOME',
      crumbs: () => [{
        to: APP.ROUTES.DASHBOARD,
        translationTitleKey: 'PAGES.HOME',
      }],
    },
    children: [
      { path: APP.ROUTES.DASHBOARD, element: <LazyHomePage /> },
      {
        path: APP.ROUTES.NUTRITIONS,
        element: <LazyNutritionsPage />,
        handle: {
          translationTitleKey: 'PAGES.NUTRITIONS',
          crumbs: () => [{
            to: APP.ROUTES.NUTRITIONS,
            translationTitleKey: 'PAGES.NUTRITIONS',
          }],
        },
      },
      {
        path: APP.ROUTES.INGREDIENTS,
        element: <LazyIngredientsPage />,
        handle: {
          translationTitleKey: 'PAGES.INGREDIENTS',
          crumbs: () => [{
            to: APP.ROUTES.INGREDIENTS,
            translationTitleKey: 'PAGES.INGREDIENTS',
          }],
        },
      },
      { path: '*', element: <Navigate to={APP.ROUTES.DASHBOARD} replace /> },
    ],
  },
]);

export const Router = (): React.JSX.Element => {
  const { state } = useAuthContext();

  return (
    <Suspense fallback={<Loader />}>
      {state.initialized ? <RouterProvider router={router} /> : <Loader />}
    </Suspense>
  );
};
